import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  FunctionField,
  ListProps,
  DateInput,
  ReferenceField,
} from "react-admin";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ActionsMenu from "../../components/ActionsMenu";
import CustomDateField from "../../components/CustomDateField";
import CustomArrayChipField from "../../components/CustomArrayChipField";
import ListEditButton from "../../components/ListEditButton";
import { SchoolIdSelected } from "../../utils/tools";
import moment from "moment";

const DryRunScheduleFilter = (props: any) => (
  <Filter {...props}>
    <DateInput source="Date" label="Date" alwaysOn />
  </Filter>
);

const DryRunScheduleList = (props: ListProps) => {
  const breadcrumb = [{ link: "/dryRunSchedules", title: "Dry Run Schedules" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Dry Run Schedules"
        denseMode
        {...props}
        exporter={false}
        filters={<DryRunScheduleFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        sort={{
          field: "date",
          order: "DESC",
        }}
        bulkActionButtons={false}
      >
        <Datagrid>
          <TextField source="id" emptyText="-" />
          <ReferenceField
            source="schoolId"
            label="School"
            reference="schools"
            emptyText="-"
            link="show"
          >
            <TextField source="name" />
          </ReferenceField>
          <CustomDateField source="date" emptyText="-" />
          <CustomArrayChipField
            label="Wave"
            source="busSchedules"
            chipSource="name"
          />
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  <ListShowButton record={record} />,
                  moment(record.date).isAfter(moment(), "day") && (
                    <ListEditButton record={record} />
                  ),
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default DryRunScheduleList;
